import React, { useContext } from "react";
import "./Why_choose_us.css";
import { Context } from "../../../utils/context";

function Why_choose_us() {
  const { language } = useContext(Context);

  return (
    <>
      <section className="Why_choose_us">
        <div className="container">
          <div className="row">
            <div className="col-md-3 p-0 order-md-1 order-3">
              <div className="row me-0 ms-0">
                <div className="col-md-12 p-0">
                  <div className="box_content_holder blue_box">
                    <div className="box_icon_img_holder">
                      <img
                        src="/assets/images/home/why_choose_us/search.png"
                        alt="search"
                        className="box_icon_img"
                      />
                    </div>
                    <div className="text_holder">
                      <h6>
                        {language == 1 ? (
                          <>
                            Hassle-Free <br /> Application
                          </>
                        ) : (
                          <>
                            Candidature <br /> sans tracas
                          </>
                        )}
                      </h6>
                      <p>
                        {language == 1
                          ? "Step-by-step support from start to submission."
                          : "Accompagnement étape par étape, du début à la soumission."}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 p-0">
                  <div className="box_content_holder brown_box">
                    <div className="box_icon_img_holder">
                      <img
                        src="/assets/images/home/why_choose_us/student.png"
                        alt="student"
                        className="box_icon_img"
                      />
                    </div>
                    <div className="text_holder">
                      <>
                        <h6>
                          {language == 1 ? (
                            <>
                              Expert <br /> Guidance
                            </>
                          ) : (
                            <>
                              Conseils <br /> d’experts
                            </>
                          )}
                        </h6>

                        <p>
                          {language == 1
                            ? "Mentors who help you choose what’s right for you."
                            : "Des mentors qui vous aident à choisir ce qui vous convient."}
                        </p>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 p-0 order-md-2 order-2">
              <div className="main_img_holder">
                <img
                  src="/assets/images/home/why_choose_us/main_img.webp"
                  alt="main img"
                  className="main_img"
                />
              </div>
            </div>

            <div className="col-md-5 p-0 order-md-3 order-1">
              <div className="row me-0 ms-0">
                <div className="col-md-12 p-0">
                  <div className="content_holder">
                    <div>
                      <h4>{language == 1 ? "Why" : "Pourquoi"}</h4>
                      <h4>{language == 1 ? "Choose" : "Choisir"}</h4>
                      <h4>{language == 1 ? "Us?" : "Nous ?"}</h4>

                      <p>
                        {language == 1
                          ? "We make your study abroad journey simple, guided, and stress-free."
                          : "Nous rendons votre parcours d’études à l’étranger simple, accompagné et sans stress."}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 p-0">
                  <div className="box_content_holder brown_box">
                    <div className="box_icon_img_holder">
                      <img
                        src="/assets/images/home/why_choose_us/globe.png"
                        alt="Globe"
                        className="box_icon_img"
                      />
                    </div>
                    <div className="text_holder">
                      <h6>
                        {language == 1 ? (
                          <>
                            Global <br /> Network
                          </>
                        ) : (
                          <>
                            Réseau <br /> mondial
                          </>
                        )}
                      </h6>

                      <p>
                        {language == 1
                          ? "Verified partners across education and industry."
                          : "Partenaires vérifiés dans l’éducation et l’industrie."}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 p-0">
                  <div className="box_content_holder blue_box">
                    <div className="box_icon_img_holder ">
                      <img
                        src="/assets/images/home/why_choose_us/meet.png"
                        alt="meet"
                        className="box_icon_img"
                      />
                    </div>
                    <div className="text_holder">
                      <h6>
                        {language == 1 ? (
                          <>
                            Personalized <br /> Counselling
                          </>
                        ) : (
                          <>
                            Conseil <br /> personnalisé
                          </>
                        )}
                      </h6>

                      <p>
                        {language == 1
                          ? "Programs matched to your goals and readiness."
                          : "Programmes adaptés à vos objectifs et à votre niveau de préparation."}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Why_choose_us;
